import {User} from "../../core/user/user.types";
import {Company} from "../../modules/models/company.type";

export interface CompanyState {
    currentCompany: Company | null;
}

export const initialCompanyState: CompanyState = {
    currentCompany: null,
};